<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form"
    @submit.prevent="onSubmit"
  >
    <v-expansion-panels
      v-model="panel"
      class="app-expansion-panels"
    >
      <v-expansion-panel @click.stop="changeCollapse">
        <v-expansion-panel-header class="app-expansion-panel-header mb-0">
          <h4 class="text">
            <v-icon>filter_alt</v-icon>
            <span>Filtrar Pedidos</span>
          </h4>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="app-expansion-panel-content">
          <v-row class="mt-3">
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >
              <SearchOrderTypeSelect v-model="table.paginate.input.type_key" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >
              <SearchOrderStatusSelect v-model="table.paginate.input.status" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >
              <SearchOrderVehiclePlateField v-model="table.paginate.input.plate" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >
              <SearchOrderCompanySelect v-model="table.paginate.input.company_id" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >
              <SearchOrderPaymentStatusSelect v-model="table.paginate.input.payment_status" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >
              <v-text-field
                v-model="table.paginate.input.group"
                placeholder="Ex:. G-1001"
                label="Grupo"
                outlined
                dense
              />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="3"
              :xs="12"
              class="pt-1"
            >              
              <SearchOrderInspectionStatusSelect v-model="table.paginate.input.inspection_status" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >                            
              <SearchOrderCreatedSelect v-model="table.paginate.input.created_at" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >              
              <SearchOrderInspectionCreatedSelect v-model="table.paginate.input.inspection_created_at" />
            </v-col>
            <v-col
              :lg="3"
              :md="3"
              :sm="6"
              :xs="12"
              class="pt-1"
            >
              <SearchOrderValidUntilSelect v-model="table.paginate.input.valid_until" />
            </v-col>
          </v-row>
          <v-divider />
          <div class="mt-3 d-flex">
            <v-spacer />
            <v-btn
              outlined
              color="error"
              type="button"
              class="mr-2"
              @click.prevent.stop="clearFilter"
            >
              <v-icon size="14">
                delete
              </v-icon>Limpar Filtros
            </v-btn>
            <v-btn
              depressed
              color="success"
              type="submit"
            >
              Filtrar
            </v-btn>
          </div>
          <section
            v-if="table.isLoading"
            class="loading"
          >
            <v-progress-circular
              indeterminate
              color="success"
            />
          </section>
          <div id="endForm" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>    
  </v-form>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  import SearchOrderTypeSelect from './components/SearchOrderTypeSelect.vue';
  import SearchOrderStatusSelect from './components/SearchOrderStatusSelect.vue';
  import SearchOrderCompanySelect from './components/SearchOrderCompanySelect.vue';
  import SearchOrderPaymentStatusSelect from './components/SearchOrderPaymentStatusSelect.vue';
  import SearchOrderInspectionStatusSelect from './components/SearchOrderInspectionStatusSelect.vue';
  import SearchOrderVehiclePlateField from './components/SearchOrderVehiclePlateField.vue';
  import SearchOrderCreatedSelect from './components/SearchOrderCreatedSelect.vue';
  import SearchOrderInspectionCreatedSelect from './components/SearchOrderInspectionCreatedSelect.vue';
  import SearchOrderValidUntilSelect from './components/SearchOrderValidUntilSelect.vue';

  import dayjs from 'dayjs'

  export default {
    components: {
      SearchOrderTypeSelect,
      SearchOrderStatusSelect,
      SearchOrderCompanySelect,
      SearchOrderPaymentStatusSelect,
      SearchOrderInspectionStatusSelect,
      SearchOrderVehiclePlateField,
      SearchOrderCreatedSelect,
      SearchOrderInspectionCreatedSelect,
      SearchOrderValidUntilSelect
    },

    data: () => ({
      panel: null,            
    }),

    computed: {
      ...mapState('pedido', ['table']),
      ...mapState('global', ['user'])
    },

    destroyed() {
      this.clear();
    },

    watch: {
      '$route.query'() {
        this.mountedQueryParamsSearch();
      }
    },

    mounted() {      
      this.mountedQueryParamsSearch();
    },

    methods: {
      onSubmit() {
        this.changeQueryParamsSearch();
        this.$vuetify.goTo('#endForm');
      },
      
      clearFilter() {
        this.$refs.form.reset();
        this.clearQueryParamsSearch();
        this.clear();        
        this.search();
      },

      changeQueryParamsSearch() {
        const input = this.table.paginate.input;               
        this.$router.push({ 
          path: this.$route.path,
          query: { 
            ...this.$route.query,
            ...this.permittedQueryParams().reduce((obj, param) => {
              if (input[param]) {
                obj[param] = input[param];
              }
              return obj;
            }, {})
          } 
        });
      },      

      mountedQueryParamsSearch() {
        const query = this.$route.query;

        this.permittedQueryParams().forEach(param => {
          if (query[param]) {
            this.table.paginate.input[param] = query[param];
          }
        });        
      },

      clearQueryParamsSearch() {
        const query = this.$route.query;
        
        if(Object.keys(query).length === 0) return;
        
        this.$router.push({ 
          path: this.$route.path, 
          query: {} 
        });
      },

      permittedQueryParams() {
        return [
          'type_key',
          'status',
          'company_id',
          'payment_status',
          'inspection_status',
          'plate',
          'group',
          'created_at',
          'inspection_created_at',
          'valid_until',
          'expiring_in',
          'validity_expired'
        ]
      },

      changeCollapse() {},
      ...mapActions('pedido', { search: 'SEARCH' }),
      ...mapActions('pedido', { clear: 'CLEAR' }),
      ...mapActions('pedido', { changePage: 'CHANGE_PAGE' })
    },
  };
</script>
